export function selectSelectorTimeType(timeType) {
    return {
        type: 'SelectTimeType',
        timeType: timeType,
    };
}
export function highlightNumber(number) {
    return {
        type: 'HighlightNumber',
        number: number,
    };
}
export function selectHour(hour) {
    return {
        type: 'SelectHour',
        hour: hour,
    };
}
export function selectMinute(minute) {
    return {
        type: 'SelectMinute',
        minute: minute,
    };
}
export function inputChange(value) {
    return {
        type: 'InputChange',
        value: value,
    };
}
export function propsUpdate(props) {
    return {
        type: 'PropsUpdate',
        props: props,
    };
}
//# sourceMappingURL=actions.js.map